import { m8API } from 'services/production/m8';
import { normalizeM8PartnerClientDTO } from 'services/production/utils/normalizeM8PartnerClientDTO';
import { GetPartnerClientService } from 'types/services';
import { UserNotFoundError } from 'utils/errors';

export const getPartnerClient: GetPartnerClientService = async (clientId) => {
  const m8PartnerClientDTO = await m8API.partner
    .getClientById({
      idClient: clientId,
    })
    .catch((error) => {
      if (error instanceof UserNotFoundError) {
        return null;
      }

      throw error;
    });

  if (m8PartnerClientDTO) {
    return normalizeM8PartnerClientDTO(m8PartnerClientDTO).toClient(null);
  }

  return null;
};
